<template>
  <div class="row">
    <!-- <div class="col-6 d-flex justify-content-center">
      <a
        href="https://apps.apple.com/cl/app/awto-chile/id1121184276"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/badge-app-store@3x.png" class="img-fluid" />
      </a>
    </div>
    <div class="col-6 d-flex justify-content-center">
      <a
        href="https://play.google.com/store/apps/details?id=com.mobiag.awto"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/badge-google-play@3x.png" class="img-fluid" />
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'a-row-store',
};
</script>
